var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E9F0FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1334_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 21.75C14.66 21.75 10 22.92 10 25.25V27H24V25.25C24 22.92 19.34 21.75 17 21.75ZM12.34 25C13.18 24.42 15.21 23.75 17 23.75C18.79 23.75 20.82 24.42 21.66 25H12.34ZM17 20C18.93 20 20.5 18.43 20.5 16.5C20.5 14.57 18.93 13 17 13C15.07 13 13.5 14.57 13.5 16.5C13.5 18.43 15.07 20 17 20ZM17 15C17.83 15 18.5 15.67 18.5 16.5C18.5 17.33 17.83 18 17 18C16.17 18 15.5 17.33 15.5 16.5C15.5 15.67 16.17 15 17 15ZM24.04 21.81C25.2 22.65 26 23.77 26 25.25V27H30V25.25C30 23.23 26.5 22.08 24.04 21.81ZM23 20C24.93 20 26.5 18.43 26.5 16.5C26.5 14.57 24.93 13 23 13C22.46 13 21.96 13.13 21.5 13.35C22.13 14.24 22.5 15.33 22.5 16.5C22.5 17.67 22.13 18.76 21.5 19.65C21.96 19.87 22.46 20 23 20Z",
    fill: "#2990FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1334_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.e4853968622e2d8814a04673643860c0.svg";
export { ForwardRef as ReactComponent };